import { QueryClientProvider as TanstackQueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ReactNode } from "react";

import { useCreateQueryClient } from "./hooks/useCreateQueryClient";

export const QueryClientProvider = ({ children }: { children: ReactNode }) => {
  const createQueryClient = useCreateQueryClient();

  return (
    <TanstackQueryClientProvider client={createQueryClient()}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </TanstackQueryClientProvider>
  );
};
